import React from 'react';
import BaseSizeSensitiveComponent from './../components/BaseSizeSensitiveComponent';
import HoverButton from '../components/HoverButton';
import ReactDOM from "react-dom";
import Home from "../Home";
import NavMenuItem from "../NavMenuItem";

var http;

class ContactForm extends BaseSizeSensitiveComponent {

    constructor(props) {
        super(props);

        this.state.hover = false;

//        this.toggleHover.bind(this);
        this.toggleHover = this.toggleHover.bind(this);
        this.onSend = this.onSend.bind(this);
        this.goBack = this.goBack.bind(this);
    }

    toggleHover(e) {
        if(this) {
            this.setState(
                {
                    hover: !this.state.hover
                }
            );
            console.log("toggleHover()");
        }
        e.stopPropagation();
    }

    goBack() {
        this.props.history.goBack();
    }

    onSend() {
        console.log("onSend()");
        var name = this.refs["name"].value.split("\"").join("");
        var company = this.refs["company"].value.split("\"").join("");
        var email = this.refs["email"].value.split("\"").join("");
        var phone = this.refs["phone"].value.split("\"").join("");
        var projdesc = this.refs["projdesc"].value.split("\"").join("");
        // Send here
        console.log(name);
        var _this = this;

        var payload = '{"name":"' + name + '", "org":"' + company +'", "email": "' + email + '", "phone": "' + phone + '", "message": "' + projdesc + '"}';
        http = new XMLHttpRequest();
        // var url = 'http://localhost:8079/contactme';  // for local dev
        var url = 'https://slackbot-contact.roywatson.com/contactme';  // for local dev
        http.open('POST', url, true);
//        http.setRequestHeader("Content-Type", "text/json");
        http.onreadystatechange = function() {
            if(http.readyState === 4 && http.status === 200) {
//                alert(http.responseText);
            }
            _this.goBack();
        }
        var jsonstr = JSON.stringify(payload);
        http.send(payload);


    }


    render() {

        var viewWidth = this.state.viewport.width;
        this.styler.setWidth(viewWidth);

        return (
            <div style={this.styler.currStyles.ContactPage.Container}>
                <div style={this.styler.currStyles.ContactPage.SubContainer}>
                    <div style={this.styler.currStyles.ContactPage.SubSubContainer}>
                        <span style={this.styler.currStyles.ContactPage.Header} >Contact Me</span>
                        <input placeholder="Name:" style={this.styler.currStyles.ContactPage.Field} type="text" ref="name"/>
                        <input placeholder="Organization:" style={this.styler.currStyles.ContactPage.Field} type="text" ref="company"/>
                        <input placeholder="E-mail:" style={this.styler.currStyles.ContactPage.Field} type="text" ref="email"/>
                        <input placeholder="Phone:" style={this.styler.currStyles.ContactPage.Field} type="text" ref="phone"/>
                        <textarea placeholder="Project description:" style={this.styler.currStyles.ContactPage.Field} rows="12" cols="50" ref="projdesc"/>
                        <HoverButton normStyle={this.styler.currStyles.ContactPage.Submit} hoverStyle={this.styler.currStyles.ContactPage.SubmitHover} onClickCallback={this.onSend}/>
                        <div style={this.styler.currStyles.ContactPage.CenteredGraph}>Or email at: <a href="mailto:rwatson@roywatson.com?subject=re:Contact Me">rwatson@roywatson.com</a></div>
                        <span style={this.styler.currStyles.ContactPage.CenteredGraph}>Or call: +1 802.735.1500</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default ContactForm


// WEBPACK FOOTER //
// src/ContactMe/ContactForm.js